import { call, put } from 'redux-saga/effects';

import api, { makeOptions } from '../../services/api';
import LdGastosEstimativaListActions from '../ducks/ld-gastos-estimativa';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetchSelect(action) {
  try {
    // const authData = yield select(getAuthData);
    const url = `ld-gastos-estimativa?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));
    yield put(LdGastosEstimativaListActions.showSuccess(list));
  } catch (err) {
    yield put(
      LdGastosEstimativaListActions.showFailure(
        err.response.data.error.message,
      ),
    );
  }
}
